import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { KnowledgeBaseComponent } from './components/home/knowledge-base.component';
import { KnowledgeBaseAiComponent } from './components/ai/knowledge-base-ai.component';
import { ViewKnowledgeBaseComponent } from './components/view-knowledge-base/view-knowledge-base.component';

import { HelperService } from '@app/core';

const routes: Routes = [
  {
    path: '', component: KnowledgeBaseComponent,
    data: {
      title: "Knowledge Base | StartDeck",
      logo: HelperService.getLogo(1)
    }
  },
  {
    path: 'ai/:identifire', 
    component: KnowledgeBaseAiComponent,
    data: {
      title: "Knowledge Base AI| StartDeck",
      logo: HelperService.getLogo(1)
    }
  },
  { path: ':slug', component: ViewKnowledgeBaseComponent, data: { logo: HelperService.getLogo(1) } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KnowledgeBaseRoutingModule { }